export default __webpack_public_path__ + "static/media/search.6b433a07.svg";